import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useAppConstantsContext } from '@/context/AppConstants';

export const APPLE_EXCLUDED_BRANDS = [
  'Ownerly',
  'PeopleSmart',
  'ReversePhone',
  'MoneyBot5000',
];

export const useSsoPromoLogic = (): {
  brandName: string;
  showApple: boolean;
  isOnSsoTest: boolean;
} => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const showApple = !APPLE_EXCLUDED_BRANDS.includes(brandName);
  const isOnSsoTest = useFeatureIsOn('RTRN-68');

  return { brandName, showApple, isOnSsoTest };
};
